export enum FilterOperator {
  Contains = 'contains',
  Equals = '==',
  GreaterThan = '>',
  LessThan = '<',
  Null = 'null',
}
